// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__vFLY6","title":"Images90_title__2Lyf9","images":"Images90_images__1BMK_"};